var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.077,
    height: 18.024,
    viewBox: "0 0 18.077 18.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(-129.923 -541.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 18,
    height: 18,
    transform: "translate(130 541.84)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_366184_answer_call_phone_icon",
    "data-name": "366184_answer_call_phone_icon",
    d: "M16.061,17.757h0c-1.486,0-4.192-.934-8.637-5.379C4.781,9.736,3.083,7.442,2.375,5.561c-.765-2.034-.163-3.055.264-3.482L4.156.563A1.777,1.777,0,0,1,6.815.729L8.661,3.1a1.773,1.773,0,0,1-.008,2.193l-.417.528a1.067,1.067,0,0,0,.083,1.416l4.244,4.244a1.088,1.088,0,0,0,1.416.083l.528-.417a1.825,1.825,0,0,1,2.193-.008l2.373,1.847a1.777,1.777,0,0,1,.165,2.659l-1.516,1.516A2.249,2.249,0,0,1,16.061,17.757ZM5.411.753a1.06,1.06,0,0,0-.754.312L3.142,2.581c-.529.529-.566,1.5-.1,2.73C3.711,7.1,5.356,9.306,7.926,11.876c4.5,4.5,7.028,5.171,8.135,5.171h0a1.564,1.564,0,0,0,1.159-.387l1.516-1.516a1.067,1.067,0,0,0-.1-1.6L16.265,11.7a1.089,1.089,0,0,0-1.317,0l-.528.417a1.784,1.784,0,0,1-1.1.383,1.764,1.764,0,0,1-1.257-.521L7.817,7.74a1.777,1.777,0,0,1-.138-2.358L8.1,4.855a1.065,1.065,0,0,0,0-1.317L6.254,1.165A1.061,1.061,0,0,0,5.411.753Z",
    transform: "translate(128.081 541.957)",
    fill: "#929292",
    stroke: "#929292",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6e6c8ceb64ef8750e088563fdb170857.svg";
export { ForwardRef as ReactComponent };